import React, { useEffect, useState } from 'react';
import { UTILITY_OFFLINE_PAYMENT_TAB } from '../../Utils/appConstants';
import BBPSIP from '../bharatBillpayIP/commonBillPayment.js';
import BBPSIMW from '../bharatBillpayImWallet/commonBillPayment.js';
import Maintenance from '../Maintenance';
import { reactLocalStorage } from 'reactjs-localstorage';
import 'antd/dist/antd.css';
import { Tabs, Card, Spin } from 'antd';
import axios from 'axios';
import { API_URL } from '../../config';

const { TabPane } = Tabs;

// Brand colors
const PRIMARY_COLOR = '#C9262C';

function FastagBillPayment(props) {
  const [tabKey, setTabKey] = useState('1');
  const [appInfo, setAppInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('props.location.tab -----------', props.location.tab);
    if (props.location.tab) {
      setTabKey(props.location.tab);
    }
  }, [props.location.tab]);

  // Fetch appInfo on component mount
  useEffect(() => {
    fetchAppInfo();
  }, []);

  const fetchAppInfo = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_URL + `/appinfo`);
      console.log('AppInfo fetched:', response.data);
      setAppInfo(response.data);
    } catch (err) {
      console.error("Failed to fetch app info", err);
    } finally {
      setLoading(false);
    }
  };

  // Get feature flags
  const isBbpsImWalletAvailable = appInfo?.bbpsImWalletEnabled || false;
  const isBbpsIpAvailable = appInfo?.bbpsIpEnabled !== undefined ? appInfo.bbpsIpEnabled : true;

  const onchangeTab = (index) => {
    reactLocalStorage.set(UTILITY_OFFLINE_PAYMENT_TAB, index, true);
    setTabKey(index);
  };

  const isUnderMaintenance = false;

  // ---- Build only enabled tabs ----
  const getEnabledItems = () => {
    const items = [];

    if (isBbpsImWalletAvailable) {
      items.push({
        key: '1',
        label: (
          <div className="tabtext" title="FASTAG-I">
            <span>
              <img height="35" width="35" src="/images/fastag-logo-icon.svg" alt="fastag" />
            </span>
            FASTAG-I
          </div>
        ),
        children: <BBPSIMW category="Fastag" />
      });
    }

    if (isBbpsIpAvailable) {
      items.push({
        key: '2',
        label: (
          <div className="tabtext" title="FASTAG-II">
            <span>
              <img height="35" width="35" src="/images/fastag-logo-icon.svg" alt="fastag" />
            </span>
            FASTAG-II
          </div>
        ),
        children: <BBPSIP category="FASTag Recharge" />
      });
    }

    return items;
  };

  const items = getEnabledItems();

  // ---- Determine valid active tab ----
  const getValidTabKey = () => {
    const enabledKeys = items.map(item => item.key);
    if (enabledKeys.includes(tabKey)) {
      return tabKey;
    }
    return enabledKeys.length > 0 ? enabledKeys[0] : '1';
  };

  const activeTabKey = getValidTabKey();

  // ---- Show fallback if no services are available ----
  if (!loading && items.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '60px 20px' }}>
        <h3>No FASTag services available</h3>
        <p>Please contact support for more information.</p>
      </div>
    );
  }

  // Show loading spinner while fetching appInfo
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
        <Spin size="large" tip="Loading services..." />
      </div>
    );
  }

  // CSS for full width and tab spacing
  const tabStyles = `
    .fastag-full-width .ant-tabs-nav {
      margin-bottom: 24px;
    }
    .fastag-full-width .ant-tabs-nav .ant-tabs-tab {
      margin-right: 20px !important;
      padding: 12px 24px !important;
    }
    .fastag-full-width .ant-tabs-nav .ant-tabs-tab:last-child {
      margin-right: 0 !important;
    }
    .fastag-full-width .ant-tabs-tab .tabtext {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: bold;
    }
    .fastag-full-width .ant-tabs-tab .tabtext span {
      display: flex;
      align-items: center;
    }
    .fastag-header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }
    .fastag-logo-img {
      cursor: pointer;
      transition: transform 0.3s;
    }
    .fastag-logo-img:hover {
      transform: scale(1.05);
    }
    .fastag-card {
      border-radius: 0 !important;
      margin: 0 !important;
      box-shadow: none !important;
      border: none !important;
    }
    .fastag-card .ant-card-body {
      padding: 20px !important;
    }
  `;

  return (
    <div>
      <style>{tabStyles}</style>
      {isUnderMaintenance ? (
        <Maintenance />
      ) : (
        <div className="content-wrapper pt-2" style={{ padding: 0 }}>
          <div className="content-header my-0 py-0">
            <div className="container-fluid" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div className="fastag-header-container">
                <div>
                  <h1 className="page-title text-blue font-merriweather" style={{ margin: 0 }}>
                    FASTag <span className="text-red">Services</span>
                  </h1>
                </div>
                <div>
                  <img
                    className='fastag-logo-img'
                    src='../images/bharat_connect.png'
                    width="100"
                    alt='Bharat Connect'
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="content" style={{ padding: 0 }}>
            <div className="container-fluid pt-2 pb-5" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div className="row" style={{ margin: 0 }}>
                <div className="col-md-12" style={{ padding: 0 }}>
                  <Card
                    className="fastag-card rounded-0"
                    style={{
                      borderRadius: 0,
                      margin: 0,
                      boxShadow: 'none',
                      border: 'none'
                    }}
                    bodyStyle={{ padding: '20px' }}
                  >
                    <Tabs
                      className="recharge-tabs fastag-full-width"
                      activeKey={activeTabKey}
                      defaultActiveKey={activeTabKey}
                      onChange={onchangeTab}
                      size="large"
                      tabBarGutter={20}
                      style={{ width: '100%' }}
                      destroyInactiveTabPane={true}  // ← Prevents API calls from inactive tabs
                    >
                      {items.map(item => (
                        <TabPane tab={item.label} key={item.key}>
                          {item.children}
                        </TabPane>
                      ))}
                    </Tabs>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FastagBillPayment;